export default class wt {
  constructor(t, s, i, h, l) {
    (this.triggerId = t),
      (this.Qr = s),
      (this.Hr = i),
      (this.Ur = h),
      (this.Vr = l),
      (this.triggerId = t),
      (this.Qr = s),
      (this.Hr = i),
      (this.Ur = h),
      (this.Vr = l);
  }
  static fromJson(t, s, i, h, l) {
    return null == t || null == t.trigger_id
      ? null
      : new wt(t.trigger_id, s, i, h, l);
  }
}
